import { BASE_URL, SANDBOX_BASE_URL, DEFAULT_HEADERS } from "./constants"
import { ApiErrors } from "./exceptions"

export function createRequest(
  apiKey: string,
  sandbox: boolean
): <TResponse>(
  path: string,
  options: Parameters<typeof fetch>[1]
) => Promise<TResponse> {
  const url = sandbox ? SANDBOX_BASE_URL : BASE_URL
  const defaultHeaders = DEFAULT_HEADERS(apiKey)

  return async <TResponse>(
    path: string,
    options: Parameters<typeof fetch>[1]
  ): Promise<TResponse> => {
    try {
      const response = await fetch(`${url}${path}`, {
        ...options,
        headers: { ...defaultHeaders, ...options?.headers },
      })

      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const data: any = await response.json()
        if (!response.ok) {
          return { errors: data.errors, data: null } as TResponse
        }
        return { data, errors: null } as TResponse
      } catch (error) {
        if (!response.ok && response.status in ApiErrors) {
          return {
            data: null,
            errors: [ApiErrors[response.status as keyof typeof ApiErrors]],
          } as TResponse
        }
        return {
          data: null,
          errors: [
            {
              code: "sdk_error",
              description: (error as Error).message,
            },
          ],
        } as TResponse
      }
    } catch (error) {
      return {
        errors: {
          code: "sdk_error",
          description: (error as Error).message,
        },
        data: null,
      } as TResponse
    }
  }
}
